import React from 'react';
export function Footer() {
  return <footer className="bg-brand-dark text-brand-text py-8 px-4 border-t border-black/10" data-id="element-88">
      <div className="max-w-3xl mx-auto text-center" data-id="element-89">
        <p className="text-sm font-bold mb-2" data-id="element-90">
          📜 KIT COMPLETO FILOSOFÍA LISTA
        </p>
        <p className="text-xs mb-4" data-id="element-91">Hecho por docentes, para docentes.</p>
        <p className="text-xs text-brand-text/60" data-id="element-92">
          © 2026 Kit Filosofía Lista — Todos los derechos reservados
        </p>
      </div>
    </footer>;
}